import useSWR from 'swr';
import { ColorSwatchInterface } from '../../components/ColorSwatch/colorSwatch';
import useFetcher from '../../utils/hooks/useFetcher';

const useUserColorScales = () => {
    const { data, error, isValidating } = useSWR<ColorSwatchInterface[]>(
        `${process.env.REACT_APP_API_URL}/user/color-swatches`,
        useFetcher(),
    );

    return {
        data,
        error,
        isLoading: !data && isValidating,
    };
};

export default useUserColorScales;
